import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';
import Button from '@sdk/components/ui/buttons/Button';

export const LocationChecklistContainer = styled.div`
  display: flex;
  background-color: ${({ theme }): string => theme.colors.white};
  border-radius: 3px;
  border: 1px solid ${({ theme }): string => theme.colors.separatorOnWhite};
  margin-right: 10px;
  max-height: 36px;
`;

export const ChecklistHeaderRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
`;

export const LocationCounterRow = styled(Row)`
  width: 40%;
`;

export type ChecklistContentContainerProps = {
  isActive: boolean;
};

export const ChecklistContentContainer = styled(Column)<ChecklistContentContainerProps>`
  background-color: ${({ theme }): string => theme.colors.white};
  visibility: ${({ isActive }): string => (isActive ? 'visible' : 'hidden')};
  max-height: 280px;
  outline: none;
  padding-top: 10px;
  margin-top: 1px;
  border-radius: 3px;
  z-index: 2;
  opacity: ${({ isActive }): number => (isActive ? 1 : 0)};
  width: 100%;
`;

export const MenuContainer = styled(Column)`
  flex: 1;
  position: relative;
  width: 205px;
`;

export const StyledButton = styled(Button)`
  max-width: 88px;
`;

export const ButtonContainer = styled(Row)`
  display: flex;
  justify-content: space-evenly;
`;
